export var BusinessCategoryEnum;
(function (BusinessCategoryEnum) {
    BusinessCategoryEnum["USERS"] = "Users";
    BusinessCategoryEnum["IDENTIFIERS"] = "Identifiers";
    BusinessCategoryEnum["PROCESSING"] = "Processing";
    BusinessCategoryEnum["TELEPHONY"] = "Telephony";
    BusinessCategoryEnum["MESSAGING"] = "Messaging";
    BusinessCategoryEnum["EXECUTABLE"] = "Executable";
    BusinessCategoryEnum["CARRIER_FEES"] = "Carrier Fees";
    BusinessCategoryEnum["DATA_STORAGE"] = "Data Storage";
    BusinessCategoryEnum["PRODUCT"] = "Product";
})(BusinessCategoryEnum || (BusinessCategoryEnum = {}));
export var LogicalCategoryEnum;
(function (LogicalCategoryEnum) {
    LogicalCategoryEnum["USAGE"] = "usage";
    LogicalCategoryEnum["USERS"] = "users";
    LogicalCategoryEnum["IDENTIFIERS"] = "identifiers";
    LogicalCategoryEnum["STORAGE"] = "storage";
})(LogicalCategoryEnum || (LogicalCategoryEnum = {}));
export var ProcessingStatus;
(function (ProcessingStatus) {
    ProcessingStatus["QUEUED"] = "queued";
    ProcessingStatus["IN_PROGRESS"] = "in_progress";
    ProcessingStatus["SUCCESS"] = "success";
    ProcessingStatus["SKIPPED"] = "skipped";
    ProcessingStatus["ERROR"] = "error";
    ProcessingStatus["CANCELLED"] = "cancelled";
})(ProcessingStatus || (ProcessingStatus = {}));
export var Status;
(function (Status) {
    Status["ACTIVE"] = "active";
    Status["NOT_ACTIVE"] = "not_active";
})(Status || (Status = {}));
export { Status as ReportingStatus };
export var ThresholdCondition;
(function (ThresholdCondition) {
    ThresholdCondition["DAILY_MAX_TRAFFIC"] = "dailyMaxTraffic";
    ThresholdCondition["WEEKLY_MAX_TRAFFIC"] = "weeklyMaxTraffic";
    ThresholdCondition["MONTHLY_MAX_TRAFFIC"] = "monthlyMaxTraffic";
})(ThresholdCondition || (ThresholdCondition = {}));
export var UsageStrategyKey;
(function (UsageStrategyKey) {
    UsageStrategyKey["PROD"] = "production";
    UsageStrategyKey["AZURE"] = "azure";
    UsageStrategyKey["DRUID"] = "druid";
    UsageStrategyKey["FALLBACK_AZURE_PRIMARY"] = "fallback:azure";
    UsageStrategyKey["FALLBACK_DRUID_PRIMARY"] = "fallback:druid";
})(UsageStrategyKey || (UsageStrategyKey = {}));
export var InvoiceType;
(function (InvoiceType) {
    InvoiceType["USAGE"] = "USAGE";
    InvoiceType["OTHER"] = "OTHER";
    InvoiceType["MANUAL"] = "MANUAL";
    InvoiceType["MEMO"] = "MEMO";
})(InvoiceType || (InvoiceType = {}));
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["DRAFT"] = "draft";
    InvoiceStatus["ISSUED"] = "issued";
    InvoiceStatus["VOIDED"] = "voided";
})(InvoiceStatus || (InvoiceStatus = {}));
export var InvoiceApprovalState;
(function (InvoiceApprovalState) {
    InvoiceApprovalState["PENDING"] = "pending";
    InvoiceApprovalState["APPROVED"] = "approved";
    InvoiceApprovalState["REJECTED"] = "rejected";
})(InvoiceApprovalState || (InvoiceApprovalState = {}));
export var PrepaymentBucket;
(function (PrepaymentBucket) {
    PrepaymentBucket["USAGE"] = "USAGE";
    PrepaymentBucket["PLATFORM"] = "PLATFORM";
    PrepaymentBucket["CUSTOM"] = "CUSTOM";
    PrepaymentBucket["VARIABLE"] = "VARIABLE";
    PrepaymentBucket["PDE"] = "PDE";
    PrepaymentBucket["PROFESSIONAL"] = "PROFESSIONAL";
    PrepaymentBucket["OTHER"] = "OTHER";
})(PrepaymentBucket || (PrepaymentBucket = {}));
export const PrepaymentInvoiceType = {
    USAGE: InvoiceType.USAGE,
    OTHER: InvoiceType.OTHER,
};
export var PrepaymentStatus;
(function (PrepaymentStatus) {
    PrepaymentStatus["ACTIVE"] = "ACTIVE";
    PrepaymentStatus["CANCELED"] = "CANCELED";
})(PrepaymentStatus || (PrepaymentStatus = {}));
//# sourceMappingURL=billing-domain.js.map